import { initFirstCriticalResource } from './firstCriticalResource';
import { initDependencies, setupDependencies } from './app';

function init() {
  let fullBundleLoaded = false;

  setupDependencies();

  initDependencies();

  setTimeout(() => {
    if (!fullBundleLoaded) {
      initFirstCriticalResource();
    }
  }, 50);

  const initFullApp = () => {
    import('./full').then(({ init: fullInit }) => {
      fullBundleLoaded = true;
      fullInit();
    });
  };
  initFullApp();
}

window.__countryside_serp_frontend_init = init;
